import ParentSchedule from "@/elements/components/schedule/parent-schedule";
import StudentSchedule from "@/elements/components/schedule/student-schedule";
import TutorSchedule from "@/elements/components/schedule/tutor-schedule";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";
import { View } from "react-native";

function LessonScheduleScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      {persona === "parent" ? (
        <ParentSchedule />
      ) : persona === "tutor" ? (
        <TutorSchedule />
      ) : persona === "student" ? (
        <StudentSchedule />
      ) : (
        <Fragment />
      )}
    </View>
  );
}

export default LessonScheduleScreen;
